// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Hj4A2TAxeHOt29rFxMIOo","wrapperPositive":"_3ykFpPbkoX0giKJ2Jkxv0L","wrapperNegative":"_1SLh5MTtOltfH-OUhuxtC","cancelButton":"_6G7eJTCTACumEAaPd2e95"};